var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": true,
        "before-close": _vm.closeWin,
        visible: _vm.showUserSelect,
        title: _vm.title,
        width: "70%",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showUserSelect = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "app-container" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 9, sm: 6, md: 5, lg: 4, xl: 4 } },
                [
                  _c(
                    "div",
                    { staticClass: "head-container" },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入关键字进行过滤" },
                        model: {
                          value: _vm.filterText,
                          callback: function ($$v) {
                            _vm.filterText = $$v
                          },
                          expression: "filterText",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-tree", {
                    ref: "tree",
                    attrs: {
                      data: _vm.deptDatas,
                      props: _vm.defaultProps,
                      load: _vm.getDeptDatas,
                      "expand-on-click-node": true,
                      lazy: "",
                      "filter-node-method": _vm.filterNode,
                    },
                    on: { "node-click": _vm.handleNodeClick },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { xs: 15, sm: 18, md: 19, lg: 20, xl: 20 } },
                [
                  _c("div", { staticClass: "head-container" }, [
                    _c(
                      "div",
                      [
                        _c("el-input", {
                          staticClass: "filter-item",
                          staticStyle: { width: "200px" },
                          attrs: {
                            clearable: "",
                            size: "small",
                            placeholder: "输入名称或者邮箱搜索",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.crud.toQuery($event)
                            },
                          },
                          model: {
                            value: _vm.query.blurry,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "blurry", $$v)
                            },
                            expression: "query.blurry",
                          },
                        }),
                        _vm._v(" "),
                        _c("rrOperation"),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.crud.loading,
                          expression: "crud.loading",
                        },
                      ],
                      ref: "table",
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.crud.data },
                      on: {
                        "selection-change": _vm.crud.selectionChangeHandler,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          selectable: _vm.checkboxT,
                          type: "selection",
                          width: "55",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": true,
                          prop: "username",
                          label: "用户名",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": true,
                          prop: "nickName",
                          label: "昵称",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": true,
                          prop: "phone",
                          width: "100",
                          label: "电话",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": true,
                          prop: "dept",
                          label: "部门",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", [
                                  _vm._v(_vm._s(scope.row.dept.name)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { "show-overflow-tooltip": true, label: "岗位" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return _vm._l(scope.row.jobs, function (item) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: item.id,
                                    attrs: { type: item.name, effect: "plain" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.name) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              })
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          width: "115",
                          align: "center",
                          fixed: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onSelect(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("选择")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("pagination"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }